<template>
  <div class="x-tablelist-view" data-automation="apply">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @input="seach"
      @search="seach"
      @resetsearch="resetsearch"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        :emptyText="$t('HT.nodata')"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>

<script>
import addApply from './template/addApply';
import bindProduct from './template/bindProduct';
import unbindApi from './template/unbindApi';
import approval from './template/approval';
import passDot from './template/passDot';
export default {
  components: {
    addApply,
    bindProduct,
    unbindApi,
    approval,
    passDot
  },
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'input',
          width: '290px',
          key: 'name',
          placeholder: this.$t('HT.rules.addApply.name')
        },
        {
          type: 'button',
          text: this.$t('HT.reset'),
          plain: true,
          event: 'resetsearch'
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.unbindApply.name'),
          tooltip: true,
          prop: 'name'
        },
        {
          label: this.$t('HT.bindAccessIp.appId'),
          prop: 'id',
          tooltip: true
        },
        {
          label: this.$t('HT.delTime'),
          prop: 'delete_date',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(4),
          width: 250,
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.recover'), this.$t('HT.delete')],
                colors: ['#0087ff'],
                event: ['recovery', 'del']
              },
              on: {
                recovery: () => {
                  const title = this.$t('HT.recoveryList.recovery');
                  const content = this.$t('HT.recoveryList.recovery.content');
                  this.$uxModal.show({
                    title,
                    content,
                    confirm: () => {
                      this.patch(params.id);
                    }
                  });
                },
                del: () => {
                  const title = this.$t('HT.recoveryList.del');
                  const content = this.$t('HT.recoveryList.del.content');
                  this.$uxModal.show({
                    title,
                    content,
                    confirm: () => {
                      this.delList(params.id);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        name: '', // 应用名称
        status: false, // 已删除
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      },
      apiList: [],
      product: []
    };
  },
  created() {
    this.getList(this.filter);
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.apply.getList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },
    /**
     * 重置搜索项
    */
    resetsearch() {
      console.log('重置');
      this.filter.name = '';
      this.seach();
    },

    /**
     * 修改列表
     * @param {Number} id id
     */
    patch(id) {
      this.$uxLoading.show();
      this.$api.apply.patch(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.recoverSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(id) {
      this.$uxLoading.show();
      this.$api.apply.delList(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          if (this.tableData.list.length === 1) {
            this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
          }
          this.getList(this.filter);
        }
      });
    },

    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
